<template>
  <div class="banner"></div>

  <div class="postulacion-correcta-page">
    <div class="box-container">
       <img src="@/assets/img/icon-correcto.png" class="img-fluid" alt="Logo"/>
       <h5>¡Tu postulación fue realizada correctamente!</h5>
       <h6>Ahora contamos con tu perfil en nuestra base de datos, muchas gracias por participar del proceso</h6>
       <button class="btn-action">Ir al portal de empleos</button>
    </div>
  </div>
</template>
<style>
  .banner, .banner::after{
    height: 200px;
  }

  .postulacion-correcta-page {
     padding: 16px 48px;
  }

  .box-container{
    max-width: 320px;
    text-align: center;
    margin: 0 auto;
    color: gray;
    padding-top: 64px;
  }

  .box-container h4, .box-container h5, .box-container h6{
    color: gray;
  }

  .btn-outline-action {
    color: #23ba71;
    border-color: #23ba71;
    background-color: white;
    padding: 11px 24px;
    border-radius: 6px;
    transition: all 0.5s;
    font-weight: 600;
  }

  .btn-action {
    background-color: #23ba71;
    border: 1px solid #23ba71;
    color:white;
    padding: 11px 24px;
    border-radius: 6px;
    transition: all 0.5s;
    font-weight: 600;
    margin-top: 32px;
  }

</style>

<script>
import { Form, Field } from "vee-validate";
import { router } from "@/router";
import * as Yup from "yup";
export default {
  components: {
    Form,
    Field,
  },
  data() {
    return {
      activeTab: "developer",
      showPassword: false,
      showPassword1: false,
      password: null,
    };
  },
  mounted() {}
};
</script>
